import React from 'react';
import {
  Container,
  Title,
  Description,
  MainContent,
  ImageWrapper,
  TeacherImage,
  TestimonialsContainer,
  TestimonialCard,
  Rating,
  TestimonialText,
  AuthorInfo,
  RedCircle,
  GreenCircle,
  OrangeSquare,
  DownloadButton,
  WebsiteLink
} from './styles';

import teacherImage from '../../../images/teacher-with-books.png';

const Section4 = () => {
  return (
    <Container>
      <Title>Preciso instalar algo?</Title>
      
      <Description>
      Não, só o WhatsApp. Mas recomendamos instalar nosso app para ter acesso às certificações, 
      agendamentos, acompanhamento de resultado e planejamento completo do aprendizado.
      </Description>
      
      <MainContent>
        <ImageWrapper>
          <TeacherImage src={teacherImage} alt="Professora com livros" />
          <RedCircle />
          <GreenCircle />
          <OrangeSquare />
        </ImageWrapper>
        
        <TestimonialsContainer>
          <TestimonialCard>
            <Rating>★★★★★ 5/5</Rating>
            <TestimonialText>"Aprendi mais em 1 mês com a IA do que em 6 meses de curso tradicional!"</TestimonialText>
            <AuthorInfo>– Ana, 28 anos</AuthorInfo>
          </TestimonialCard>
          
          <TestimonialCard>
            <Rating>★★★★★ 5/5</Rating>
            <TestimonialText>"Finalmente perdi o medo de falar inglês graças às correções instantâneas!"</TestimonialText>
            <AuthorInfo>– Carlos, 45 anos</AuthorInfo>
          </TestimonialCard>
        </TestimonialsContainer>
      </MainContent>
      
      <DownloadButton>Baixar App</DownloadButton>
      <WebsiteLink>Ou acesse somente pelo WhatsApp.</WebsiteLink>
    </Container>
  );
};

export default Section4;
